<template>

    <div id="production-tree" >

        <div class="container">
            <div class="row">
                <div class="col-2"><label for="resource">Produkt</label></div>
                <div class="col-2"><select class="form-control" id="resource" v-model="resource">
                    <option v-for="item in resources" :value="item">{{ item.name }}</option>
                </select></div>
                <div class="col-2"><label for="level">Level</label></div>
                <div class="col-2"><input class="form-control" id="level" type="number" v-model="level"></div>
                <div class="col-2"><span v-if="resource">Produktionsmenge: {{(resource.data.producedAnHour*level*24).toFixed(2) }}/d</span></div>
            </div>
        </div>




        <div class="production-tree-container">

        <ProductionTree :list="productionList" :level="level"></ProductionTree>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div id="costdiagram"></div>
                </div>
            </div>
        </div>

        <div class="container">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-2">Name</div>
            <div class="col-2 text-right">Amount/day</div>
            <div class="col-2 text-right">Production/lvl/day</div>
            <div class="col-2">Level</div>
            <div class="col"></div>
        </div>
        <div class="row my-2" v-for="product in summary">

            <div class="col-1"><img class="production-tree-image" v-if="product.resource" :src="'https://d1fxy698ilbz6u.cloudfront.net/static/'+product.resource.image" alt=""></div>
            <div class="col-2">{{ product.resource.name }}</div>
            <div class="col-2 text-right">{{ (product.amount*level*24).toFixed(2) }}</div>
            <div class="col-2 text-right">{{ (product.resource.producedAnHour*24).toFixed(2) }}</div>
            <div class="col-2">{{ ((product.amount*level)/product.resource.producedAnHour).toFixed(2) }}</div>
            <div class="col-auto"><div class="btn btn-primary" @click="disableResource(productionList, product.resource.db_letter)">x</div></div>
        </div>

        </div>
    </div>
</template>

<script>

    import ProductionTree from '@/components/ProductionTree.vue'
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    /* Chart code */
    // Themes begin
    am4core.useTheme(am4themes_animated);

    export default {
        name: 'Production',

        data() {
            return {
                resource: null,
                buildings: null,
                level: 1,
                productionList: {},
                chart: null,
            }
        },
        components: {
            ProductionTree
        },
        computed: {
            resources() {
                return this.$store.state.resources;
            },
            productionListOld(){
                let me = this;
                if(this.resource) {

                    let list = {};
                    let dataList = {};

                    let amount = me.resource.data.producedAnHour;

                    list = this.getAmountsNested(list, me.resource.data, amount)

                    console.warn(list);
                   /* console.warn(list);
                    _.forEach(list, function(amount, rid) {
                        let resource = _.find(me.resources, function(o) {
                            return o.data.db_letter == rid;
                        });


                        dataList[rid] = {resource: resource.data, amount: amount}
                    })*/

                    return list;
                }
            },
            summary() {
                let me = this;
                let dataList = {};
                if(this.resource){
                    let list = {};

                    list = this.getSummary(list, this.productionList)

                    _.forEach(list, function(amount, rid) {
                        let resource = _.find(me.resources, function(o) {
                            return o.data.db_letter == rid;
                        });


                        dataList[rid] = {resource: resource.data, amount: amount}
                    })
                }

                console.log(dataList);
                return dataList;
            },
            costsSankey() {
                let me = this;
                let list = {};
                if(this.resource){


                    let amount = me.resource.data.producedAnHour;

                    list = this.getAmounts(list, me.resource.data, 1, "sankey")

                  /*  _.forEach(list, function(amount, rid) {
                        let resource = _.find(me.resources, function(o) {
                            return o.data.db_letter == rid;
                        });


                        dataList[rid] = {resource: resource.data, amount: amount}
                    })*/
                }

                console.log(list);
                return list;
            },
            productionListFlat(){
                let me = this;
                if(this.resource) {

                    let list = {};
                    let dataList = {};

                    let amount = me.resource.data.producedAnHour;

                    list = this.getAmounts(list, me.resource.data, amount)

                    console.warn(list);

                     _.forEach(list, function(amount, rid) {
                         let resource = _.find(me.resources, function(o) {
                             return o.data.db_letter == rid;
                         });


                         dataList[rid] = {resource: resource.data, amount: amount}
                     })

                    return dataList;
                }
            }
        },
        watch: {
            resource(){

                let me = this;
                if(this.resource) {

                    let list = {};
                    let amount = me.resource.data.producedAnHour;

                    list = this.getAmountsNested(list, me.resource.data, amount)

                    me.productionList = list;
                    let costsChartData = [];
                    _.forEach(me.costsSankey, function(item) {
                        costsChartData.push(item);
                    })
                    costsChartData = costsChartData.reverse();
                    me.chart.data = costsChartData;
                }
            }
        },
        methods: {
            disableResource(list, did){
                let me = this;
                _.forEach(list, function(item,rid) {
                    if(did==rid){
                        item.active = false;
                    }
                    if(item.subitems) {
                        me.disableResource(item.subitems, did);
                    }
                });
            },

            getSummary(slist, list) {
                let me = this;
                _.forEach(list, function(item,rid) {

                    if(item.active){

                        if(item.subitems){
                            slist = me.getSummary(slist, item.subitems)
                        }

                        //console.warn(typeof slist[rid]);
                        try {
                            if (typeof slist[rid] == "undefined") { //Prüft ob die Inputresource schonmal vorkam
                                slist[rid] = item.amount; //Wenn nicht dann wird die Menge zugewiesen
                            }
                            else {
                                slist[rid] += item.amount; //Wenn ja dann wird die Menge zu der vorhanden addiert
                            }
                        } catch (e) {
                            console.log('dd');
                        }
                    }
                })

                return slist;
            },
          getAmounts(list,resource, oamount, mode="flat"){ //Gibt eine Liste mit den benötigten Ressourcen pro Stunde zurück
              let me = this; //speichert das Vue object in me

              if(resource.producedFrom.length > 0){ //Prüft ob die Resource Input Resourcen hat

                  _.forEach(resource.producedFrom, function(item) { //Durchläuft alle Inputresourcen; item = resource des aktuellen duchlaufs

                      let amount = item.amount*oamount; //Berechnet die Menge der input Resource mit dem übergebenen Wert

                      let pitem = _.find(me.resources, function(oresource) {  //Sucht aus der Resourcenliste die Resource mit der id z.B. 1 = Power
                          return oresource.data.db_letter === item.resource.db_letter;
                      });

                      if(pitem.data.producedFrom.length > 0){ //Prüft ob die Inputresource auch Inputresourcen hat
                        list = me.getAmounts(list, pitem.data, amount, mode) //Falls ja wird die gleiche (getAmounts) Funktion aufgerufen für die Inputresource
                      }

                      if(mode=="flat"){
                      if(typeof list[item.resource.db_letter] == "undefined"){ //Prüft ob die Inputresource schonmal vorkam
                          list[item.resource.db_letter] = amount; //Wenn nicht dann wird die Menge zugewiesen
                      } else {
                          list[item.resource.db_letter] += amount; //Wenn ja dann wird die Menge zu der vorhanden addiert
                      }
                      } else if(mode=="sankey"){
                          if(typeof list[resource.db_letter+'-'+item.resource.db_letter] == "undefined"){ //Prüft ob die Inputresource schonmal vorkam
                              list[resource.db_letter+'-'+item.resource.db_letter] = {from: resource.name, to: item.resource.name, value: amount*pitem.minprice}; //Wenn nicht dann wird die Menge zugewiesen
                          } else {
                              list[resource.db_letter+'-'+item.resource.db_letter]['amount'] += amount*pitem.minprice; //Wenn ja dann wird die Menge zu der vorhanden addiert
                          }
                      }

                  })
              }

              return list; //Liste aller Resource wird zurückgegeben
          },
            getAmountsNested(list,resource, oamount){ //Gibt eine verschachtelte Liste mit den benötigten Ressourcen pro Stunde zurück
                let me = this; //speichert das Vue object in me

                if(resource.producedFrom.length > 0){ //Prüft ob die Resource Input Resourcen hat

                    _.forEach(resource.producedFrom, function(item) { //Durchläuft alle Inputresourcen; item = resource des aktuellen duchlaufs

                        let amount = item.amount*oamount; //Berechnet die Menge der input Resource mit dem übergebenen Wert

                        let pitem = _.find(me.resources, function(oresource) {  //Sucht aus der Resourcenliste die Resource mit der id z.B. 1 = Power
                            return oresource.data.db_letter === item.resource.db_letter;
                        });
                        list[item.resource.db_letter] = {};
                        if(pitem.data.producedFrom.length > 0){ //Prüft ob die Inputresource auch Inputresourcen hat
                            list[item.resource.db_letter]['subitems'] = {};
                            list[item.resource.db_letter]['subitems'] = me.getAmountsNested(list[item.resource.db_letter]['subitems'], pitem.data, amount) //Falls ja wird die gleiche (getAmounts) Funktion aufgerufen für die Inputresource
                        }
                        list[item.resource.db_letter]['amount'] = amount;
                        list[item.resource.db_letter]['active'] = true;
                        list[item.resource.db_letter]['price'] = pitem.minprice;
                        list[item.resource.db_letter]['resource'] = pitem.data;

                    })
                }

                return list; //Liste aller Resource wird zurückgegeben
            }
        },
        beforeMount() {
            if (JSON.parse(window.localStorage.getItem('buildings'))) {
                this.$set(this, 'buildings', JSON.parse(window.localStorage.getItem('buildings')));
            }
            else {
                fetch('https://sc.gamers-universe.eu/api/getBuildings.php', {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                    .then(response => {
                        this.buildings = _.orderBy(response, ['name'], ['asc']);

                        window.localStorage.setItem('buildings', JSON.stringify(this.buildings));
                        console.log(this.buildings);
                    }).catch(err => {
                    console.log(err);
                });
            }
        },
        mounted() {

            var chart = am4core.create("costdiagram", am4charts.SankeyDiagram);
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            chart.data = [];
            let linkTemplate = chart.links.template;
            linkTemplate.fillOpacity = 0.6;
            let hoverState = chart.links.template.states.create("hover");
            hoverState.properties.fillOpacity = 1;
            chart.height = 900;
            chart.dataFields.fromName = "from";
            chart.dataFields.toName = "to";
            chart.dataFields.value = "value";

// for right-most label to fit
            chart.paddingRight = 60;

// make nodes draggable
            let nodeTemplate = chart.nodes.template;
            nodeTemplate.inert = true;
            nodeTemplate.readerTitle = "Drag me!";
            nodeTemplate.showSystemTooltip = true;
            nodeTemplate.width = 20;
            nodeTemplate.readerTitle = "Click to show/hide or drag to rearrange";
            nodeTemplate.showSystemTooltip = true;
            nodeTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer


            this.chart = chart;
        }
    };
</script>

<style scoped lang="scss">

    img {
        max-width: 40px;
    }

    #costdiagram {
        height: 900px;
    }
    .production-tree-container {
        overflow-x: auto;
        width: 100%;
    }
</style>
